export class BorrowerLoanMessageModel {
  messageId: number;
  leadId: number | undefined;
  applicationId: number | undefined;
  loanDocTaskId: number | undefined;
  borrowerId: number | undefined;
  agentId: number | undefined;
  userId: string | undefined;
  content: string | undefined;
  flagInternalMessage: boolean;
  isLosMessage: boolean;
  postTime: Date;
  senderId: string | undefined;
  senderFirstName: string | undefined;
  senderLastName: string | undefined;
  senderDisplayName: string | undefined;
  senderAvatar: string | undefined;
  openConversationId: number;
  notifyPartyId: string[];
  mentionTrackingGuid: string | undefined;
  messageScope: MessageScope;

  companyId: number | undefined;
  insertedBy: string | undefined;
  updatedBy: string | undefined;
  dateInserted: Date | undefined;
  dateUpdated: Date | undefined;
}

export enum MessageScope {
  InternalMessage = "InternalMessage",
  BorrowerMessage = "BorrowerMessage",
  AgentMessage = "AgentMessage",
  AgentNote = "AgentNote",
  TaskNote = "TaskNote"
}
